import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { StickyCallButton } from './components/StickyCallButton';
import { CookieConsent } from './components/CookieConsent';
import { Toaster } from './components/ui/sonner';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, initScrollTracking, resetScrollTracking, initConsent } from './lib/analytics';
import HomePage from './pages/HomePage';
import UmzugBerlinPage from './pages/UmzugBerlinPage';
import MobelmontageBerlinPage from './pages/MobelmontageBerlinPage';
import EntruempelungBerlinPage from './pages/EntruempelungBerlinPage';
import KontaktPage from './pages/KontaktPage';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PageTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageView(pathname, document.title);
    resetScrollTracking();
    const cleanup = initScrollTracking();
    return cleanup;
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    initConsent();
  }, []);

  return (
    <HelmetProvider>
      <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <PageTracker />
        <div className="App bg-black min-h-screen">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/umzug-berlin" element={<UmzugBerlinPage />} />
              <Route path="/moebelmontage-berlin" element={<MobelmontageBerlinPage />} />
              <Route path="/entruempelung-berlin" element={<EntruempelungBerlinPage />} />
              <Route path="/kontakt" element={<KontaktPage />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <StickyCallButton />
          <CookieConsent />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
